<template>
  <div class="success-page">
    <h1 class="title">{{ t('thank_you_page.title') }}</h1>
    <p class="subtitle">{{ t('thank_you_page.subtitle') }}</p>
    <div class="icon-wrap">
      <svg viewBox="0 0 52 52" class="checkmark">
        <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark-check" fill="none" d="M14 27l8 8 16-16" />
      </svg>
    </div>
    <p class="message" v-html="message"></p>
  </div>
</template>

<script setup>
import { http } from '@/services/http';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
const { t } = useI18n();
const router = useRouter();
const message = ref(t('thank_you_page.message'));
onMounted( async()=>{
  await fetchInsuranceForm()
});
const fetchInsuranceForm = async () => {
	try {
		const { data } = await http.get('fetch-insurance-data')
		if (data) {
      if(data?.current_step == "employer_form"){
        return router.replace({ name: 'EmployerFormPage' });
      }
      if(data?.current_step == "health_questionnaire"){
        return router.replace({ name: 'HealthInsurance' });
      }
      if(data?.current_step == "payment"){
        return router.replace({ name: 'PaymentMethodPage' });
      }
      if(data?.status === "success"){
        message.value = t('thank_you_page.success_message');
      }
		}
	} catch (error) {
		console.error('Failed to load insurance form:', error)
	}
}
</script>

<style scoped>
.success-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.icon-wrap {
  margin-bottom: 1.5rem;
}

.checkmark {
  width: 64px;
  height: 64px;
}

.checkmark-circle {
  stroke: #22c55e;
  stroke-width: 2;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: stroke-circle 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.2s forwards;
}

.checkmark-check {
  stroke: #22c55e;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke-check 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke-circle {
  to { stroke-dashoffset: 0; }
}
@keyframes stroke-check {
  to { stroke-dashoffset: 0; }
}

.message {
  max-width: 420px;
  font-size: 1rem;
  line-height: 1.7;
  color: #374151;
}
</style>